import React from "react";
import { CustomDialog } from "../../../../../Components";
import { useTranslate } from "../../../../../Hooks";

import useStyles from "./styles";

import { AlertCircle } from "../../../../../assets/icons";

function DeleteDialog({ isOpen, onClose, onDeleteAction }) {
  const styles = useStyles();
  const { translate } = useTranslate("NewAgentsRotationCriteria");

  return (
    <CustomDialog
      paperClassName={styles.dialogWrapper}
      open={isOpen}
      onClose={() => {
        onClose(false);
      }}
      onConfirm={() => {
        onDeleteAction();
        onClose(true);
      }}
      headingIcon={
        <div className={styles.modalIcon}>
          <AlertCircle width="20" height="20" fill={"#D92D20"} />
        </div>
      }
      title={translate("delete-schema-modal-title")}
      subtitle={translate("delete-schema-modal-subtitle")}
      cancelText={translate("cancel")}
      confirmText={translate("delete")}
      hideActionsBorder
    />
  );
}

export default DeleteDialog;
